import React, { Fragment } from "react";
import styles from "./styles";
import { JsonToTable } from "react-json-to-table";
import { withStyles } from "@material-ui/core";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import CircularProgress from "@material-ui/core/CircularProgress";
import XLUtil from "./XLUtil";

class FileUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isError: null,
      uploading: false,
      responseJson: [],
      isSuccess: false,
      errorsArr: [],
    };
  }

  readFileData = (inputFile) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        resolve(event.target.result);
      };

      reader.onerror = (err) => {
        reject(err);
      };

      reader.readAsBinaryString(inputFile);
    });
  };

  handleChange = (e) => {
    this.setState({
      uploading: true,
    });
    this.readFileData(e.target.files[0])
      .then((data) => {
        const parsedJson = XLUtil.readExcelFromBuffer(data);
        return XLUtil.transformDataAndProcessFileUpload(parsedJson);
      })
      .then((result) => {
        this.setState({
          uploading: false,
          responseJson: result.result,
          isSuccess: true,
          isError: false,
          errorsArr: result.errorsArr,
        });
      })
      .catch((err) => {
        this.setState({
          uploading: false,
          isError: true,
          isSuccess: false,
          responseJson: [],
          errorsArr: [],
        });
      });
  };
  render() {
    const { classes } = this.props;
    return (
      <Fragment>
        {!this.state.uploading && (
          <div className={classes.mainContainer}>
            <div className={classes.uploadContainer}>
              <div>
                <h3>Upload Pro Details</h3>
              </div>
              <div>
                <label htmlFor="excel_converts" className={classes.choose}>
                  Upload
                </label>
                <input
                  id="excel_converts"
                  type="file"
                  accept=".csv, text/csv"
                  style={{ display: "none" }}
                  onChange={this.handleChange}
                />
              </div>
            </div>
          </div>
        )}
        <div>
          <div className={classes.outerDiv}>
            {this.state.uploading && <CircularProgress></CircularProgress>}
          </div>
          {this.state.isSuccess && (
            <div className={classes.outerDiv}>
              <div className={classes.dataContainer}>
                {this.state.responseJson.placards.length > 0 ? (
                  <div>
                    <h4>Placards : </h4>
                    <JsonToTable
                      json={this.state.responseJson.placards}
                    ></JsonToTable>
                  </div>
                ) : (
                  <div>
                    <p>
                      <span style={{ fontWeight: "bold" }}>Placards : </span>
                      N/A
                    </p>
                  </div>
                )}
                {this.state.responseJson.packingStatus ? (
                  <p>
                    <span style={{ fontWeight: "bold" }}>
                      Packing Status :{" "}
                    </span>
                    {this.state.responseJson.packingStatus}
                  </p>
                ) : (
                  <div>
                    <p>
                      <span style={{ fontWeight: "bold" }}>
                        {" "}
                        Packing Status :{" "}
                      </span>
                      N/A
                    </p>
                  </div>
                )}
                {this.state.errorsArr.length > 0 ? (
                  <div>
                    <h4>Unprocessed Pro Data : </h4>
                    <JsonToTable json={this.state.errorsArr}></JsonToTable>
                  </div>
                ) : null}
                {this.state.responseJson.invalid ? (
                  <p className={classes.invalidShipmentContainer}>
                    <span style={{ fontWeight: "bold", margin: "2px" }}>
                      Invalid Shipments :{" "}
                    </span>

                    {this.state.responseJson.invalid.map((invalidData) => (
                      <div>
                        <JsonToTable
                          json={invalidData.hazmatShipment.data}
                        ></JsonToTable>
                        <p>
                          <span style={{ fontWeight: "bold" }}>unCode : </span>
                          {invalidData.unCode}
                        </p>
                        <p>
                          <span style={{ fontWeight: "bold" }}>
                            table Group :{" "}
                          </span>
                          {invalidData.tableGroup}
                        </p>
                      </div>
                    ))}
                  </p>
                ) : null}
              </div>
            </div>
          )}
          {this.state.isError && (
            <div className={classes.outerDiv}>
              <h5 style={{ color: "red" }}>File Upload Failed</h5>
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}
export default compose(
  withStyles(styles),
  withUserProfile,
  withSnackbar
)(FileUpload);
